/**
 * V2 toasts — small transient notices (the activity ticker and milestone
 * celebrations need them; forms keep their inline text). Plain words,
 * aria-live, auto-dismiss, tappable when given an onClick.
 */
let host = null;
const MAX_VISIBLE = 3;

function ensureHost() {
  if (host?.isConnected) return host;
  host = document.createElement('div');
  host.className = 'v2-toasts';
  host.setAttribute('aria-live', 'polite');
  document.body.appendChild(host);
  return host;
}

/**
 * Show a toast.
 * @param {string} message - Plain text
 * @param {object} opts - { type: 'info'|'success'|'celebrate', onClick?, duration? }
 */
export function showToast(message, { type = 'info', onClick = null, duration = 6000 } = {}) {
  const container = ensureHost();
  while (container.children.length >= MAX_VISIBLE) container.firstChild.remove();

  const toast = document.createElement(onClick ? 'button' : 'div');
  if (onClick) toast.type = 'button';
  toast.className = `v2-toast v2-toast-${type}`;
  toast.textContent = message;
  if (onClick) {
    toast.addEventListener('click', () => {
      toast.remove();
      onClick();
    });
  }
  container.appendChild(toast);
  setTimeout(() => toast.remove(), duration);
  return toast;
}
